import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export type GoogleReviewItem = {
  authorName: string;
  profilePhotoUrl?: string;
  rating: number;
  relativeTime: string;
  text: string;
};

export type GoogleReviewsResponse = {
  rating: number;
  userRatingCount: number;
  reviews: GoogleReviewItem[];
};

export function useGoogleReviews() {
  return useQuery<GoogleReviewsResponse>({
    queryKey: ['google-reviews'],
    queryFn: async () => {
      const response = await axios.get('/api/google-reviews');
      return response.data;
    },
    staleTime: 60 * 60 * 1000, // 1h — matches the slow-changing nature of reviews
    retry: false,
  });
}
